import {getMethod, patchMethod, postMethod, putMethod} from '~/api'

async function get(request, cancelToken) {
    return await getMethod('/api/privateClients', request, cancelToken)
}

async function post(request) {
    return await postMethod('/api/privateClients', request)
}

async function put(personId, request) {
    return await putMethod(`/api/privateClients/${personId}`, request)
}

async function patch(id, request) {
    return await patchMethod(`/api/privateClients/${id}`, request)
}

export {get, post, put, patch}
